import { MarvColor, MarvColorPrimary, MarvColorBlue, MarvColorGreen, MarvColorOrange, MarvColorRed } from '@marv/types';
import { Order, MissionStatus, Pcheck } from '@app/models';

export class MissionItemOperation{
    id: number;
    name: string;
    typeOfMission: string;
    source: string;
}

export class MissionItemRetailer{
    id: number;
    name: string;
    code: string;
}

export class MissionItemStore{
    name: string;  
    code: string;
    administrativeArea: string;
    zipCode: string;
    city: string;
}

export class MissionItemArea{
    id: number;
    name: string;
}

export class MissionItemSector{
    id: number;
    name: string;
}

export class MissionItemSalesRep{
    id: number;
    name: string;
}

export class MissionItemPurposes {
    name: string;
    fulfilled: boolean;
}

export class MissionItemReport{
    id: number;
    date: Date;
    published: boolean;
    status: string;
    activityId: number;
}

export class MissionItemWorker{
    id: number;
    name: string;
    email: string;
    phone: string;
}

export class MissionItem {
    
    activityId: number; //OU storeCheckId pour lgg  
    missionId: number; //OU storeCheckId pour lgg  
    retailer: MissionItemRetailer;
    store: MissionItemStore;
    customerArea: MissionItemArea;
    customerSector: MissionItemSector;
    operation: MissionItemOperation;
    salesRep?: MissionItemSalesRep;
    day: number;
    amStartTime: string|null;
    amEndTime: string|null;
    pmStartTime: string|null;
    pmEndTime: string|null;
    duration: string;
    presenceConfirmed: boolean;
    reportingCompleted: boolean;
    reportable: boolean;
    status: MissionStatus;    
    profil: string;
    worker?: MissionItemWorker;
    quotaConsumed: number|null;
    evaluationNote: number|null;   
    description: string;
    planningEntryType: string;
    affected: boolean = false;
    report: MissionItemReport|null = null;
    purposes: Array<MissionItemPurposes> = [];
    recoCompliance: boolean = false;
    showPresenceCheckInfos: boolean = true;
    presenceCheck: Pcheck|null = null;
    nbPictures: number;
    source: 'loga'|'lgg';
          
    static SortItems(items: Array<MissionItem>, order: 'ASC'|'DESC' = 'ASC'){
        let coeffOrder = (order === 'ASC' ? 1 : -1);
        items.sort(((a, b): number => {
            if(a.day == b.day){            
                if (a.amStartTime != null && b.amStartTime != null){
                    if(a.amStartTime == b.amStartTime){
                        return 0;
                    }
                    else{
                        return (a.amStartTime > b.amStartTime ? 1 : -1) * coeffOrder;
                    }
                }
                else{
                    if(a.amStartTime == null && b.amStartTime == null){
                        return 0;
                    }
                    else{
                        return (a.amStartTime == null ? 1 : -1) * coeffOrder;
                    }
                }
            }
            else{
                return (a.day > b.day ? 1 : -1) * coeffOrder;
            }
        }));      
    }
}

